export default __webpack_public_path__ + "static/media/recruitment-layer-1.47e92663.png";